import React from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Bookmark } from 'lucide-react';

/**
 * Renders a "Saved to careers ✓" badge that flies upward from (x, y)
 * and fades out. Mounts into document.body via portal.
 */
const BookmarkFlyAnimation = ({ x, y, show, onComplete }) => {
  return createPortal(
    <AnimatePresence>
      {show && (
        <motion.div
          key="bookmark-fly"
          initial={{ opacity: 1, y: 0, scale: 1 }}
          animate={{ opacity: 0, y: -72, scale: 0.85 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.75, ease: 'easeOut' }}
          onAnimationComplete={onComplete}
          style={{
            position: 'fixed',
            left: x,
            top: y,
            zIndex: 99999,
            pointerEvents: 'none',
            transform: 'translateX(-50%)',
          }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            background: '#1ed760',
            color: '#000',
            padding: '6px 14px',
            borderRadius: '999px',
            fontSize: '12px',
            fontWeight: 700,
            whiteSpace: 'nowrap',
            boxShadow: '0 4px 16px rgba(30,215,96,0.4)',
            fontFamily: "'Inter', sans-serif",
          }}>
            <Bookmark size={12} fill="#000" />
            Saved to Roadmaps & Careers ↗
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default BookmarkFlyAnimation;
